var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0077B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.5C8.5 7.6 7.6 8.5 6.5 8.5C5.4 8.5 4.5 7.6 4.5 6.5C4.5 5.4 5.4 4.5 6.5 4.5C7.6 4.5 8.5 5.4 8.5 6.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H8.5V19.5H4.5V9.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.5H14.5V11.2H14.6C15.1 10.2 16.2 9.5 17.7 9.5C20.8 9.5 21.5 11.4 21.5 14.1V19.5H17.5V14.7C17.5 13.4 17.5 11.7 15.8 11.7C14.1 11.7 13.8 13.1 13.8 14.6V19.5H10.5V9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.3b961920b5606ffb2df4bc10a9cfd046.svg";
export { ForwardRef as ReactComponent };